export const User = [
	{
		email: 'user@gmail.com',
		password: '123',
		role: 'user',
	},
	{
		email: 'admin@gmail.com',
		password: '1234',
		role: 'admin',
	},
];